export default __webpack_public_path__ + "static/continue-upgrade-6456f99e5765d44638b1742ccda5569c.png";